module.exports = __webpack_public_path__ + "static/media/IMG_3837.c3413aea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/IMG_3837.png
// module id = 323
// module chunks = 0